import * as React from 'react';
import { useTree } from './Tree';
import { useDragAndDrop } from '../controlledEnvironment/DragAndDropProvider';
export var DragBetweenLine = function (_a) {
    var _b;
    var treeId = _a.treeId;
    var _c = useDragAndDrop(), draggingPosition = _c.draggingPosition, itemHeight = _c.itemHeight;
    var renderers = useTree().renderers;
    var shouldDisplay = draggingPosition &&
        draggingPosition.targetType === 'between-items' &&
        draggingPosition.treeId === treeId;
    if (!shouldDisplay) {
        return null;
    }
    var lineProps = {
        onDragOver: function (e) { return e.preventDefault(); }, // Allow dropping
    };
    return (React.createElement("div", { style: {
            position: 'absolute',
            left: '0',
            right: '0',
            top: "".concat(((_b = draggingPosition === null || draggingPosition === void 0 ? void 0 : draggingPosition.linearIndex) !== null && _b !== void 0 ? _b : 0) * itemHeight, "px"),
        } }, renderers.renderDragBetweenLine({
        draggingPosition: draggingPosition,
        lineProps: lineProps,
    })));
};
